import { LayoutGrid, Globe, Images, PenTool, Eraser, Film, Clapperboard, FastForward, Wallet, Handshake, LifeBuoy, BookOpen, DollarSign } from "lucide-react";
import type { ElementType } from "react";

export interface NavItem {
  href: string;
  label: string;
  icon: ElementType;
}

export const navItems: NavItem[] = [
  { href: "/", label: "Home", icon: LayoutGrid },
  { href: "/explore", label: "Explore", icon: Globe },
  { href: "/assets", label: "My Creations", icon: Images },
  { href: "/prompting-guide", label: "Prompting Guide", icon: BookOpen },
  { href: "/monetize", label: "Monetize Videos", icon: DollarSign },
];

export const creationNavItems: NavItem[] = [
  { href: "/create/text-to-image", label: "Text to Image", icon: PenTool },
  { href: "/create/image-edit", label: "Image Edit", icon: Eraser },
  { href: "/create/text-to-video", label: "Text to Video", icon: Film },
  { href: "/create/image-to-video", label: "Image to Video", icon: Clapperboard },
  { href: "/create/extend-video", label: "Extend Video", icon: FastForward },
];

export const utilityNavItems: NavItem[] = [
  { href: "/billing", label: "Stars & Pricing", icon: Wallet },
  { href: "/affiliates", label: "Affiliates", icon: Handshake },
  { href: "/support", label: "Support", icon: LifeBuoy },
];
